import { useQuery } from '@tanstack/react-query';
import { makeRemoteGetEmailQueueBlacklist } from 'main/factories/usecases/queue';

const FIVE_MINUTES = 5 * 60 * 1000;

export const useGetEmailQueueBlacklist = (locationId: string | undefined) => {
  const getEmailQueueBlacklist = makeRemoteGetEmailQueueBlacklist();

  return useQuery({
    queryKey: ['emailQueueBlacklist', locationId],
    queryFn: async () => {
      if (!locationId) return null;
      return getEmailQueueBlacklist.get({ locationId });
    },
    enabled: !!locationId,
    staleTime: FIVE_MINUTES,
    gcTime: FIVE_MINUTES,
  });
};
